import React, { lazy, Suspense } from 'react';
import { SerializedEditorState } from 'lexical';

import type { BaseLexicalProps } from './BaseLexicalComponent';

// Carga diferida de los componentes
const BaseLexicalComponent = lazy(() =>
  import('./BaseLexicalComponent').then((module) => ({
    default: module.BaseLexicalComponent,
  }))
);

const ValueUpdatePlugin = lazy(() =>
  import('./plugins/ValueUpdatePlugin').then((module) => ({
    default: module.ValueUpdatePlugin,
  }))
);

export type LexicalViewerProps = BaseLexicalProps & {
  value?: string | SerializedEditorState;
};

export function LexicalViewer({ config, ...props }: LexicalViewerProps) {
  return (
    <Suspense fallback={<div>Cargando...</div>}>
      <BaseLexicalComponent config={config} {...props} editable={false}>
        <ValueUpdatePlugin value={props.value} />
      </BaseLexicalComponent>
    </Suspense>
  );
}
